import React from 'react'
import Form from '../components/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import '../components/main.css'

const FormModal = ({showModal, setShowModal}) => {

    return (
        <>
        <div className={`${showModal ? 'form activeForm' : 'form'}`}>
            <div className="formClosed">
                <FontAwesomeIcon icon={faTimes} onClick={() => setShowModal(false)} className="formTimes"/>
            </div>
            <Form/>
        </div>
        </>
    )
}

export default FormModal
